import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import Carousel from 'react-multi-carousel';
import './MultiCarousel.css';

const MultiCarousel = forwardRef(({ responsive, children, ...rest }, ref) => (
	<Carousel ref={ref} responsive={responsive} {...rest}>
		{children}
	</Carousel>
));

// for more customization refer https://www.npmjs.com/package/react-multi-carousel
MultiCarousel.defaultProps = {
	responsive: {
		superLargeDesktop: {
			breakpoint: { max: 4000, min: 3000 },
			items: 6
		},
		desktop: {
			breakpoint: { max: 3000, min: 1024 },
			items: 6
		},
		tablet: {
			breakpoint: { max: 1024, min: 464 }, // LampsPlus UI is same for Desktop and Tablet
			items: 6
		},
		mobile: {
			breakpoint: { max: 464, min: 0 },
			items: 1
		}
	},
	slidesToSlide: 6,
	afterChange: () => {}
};

MultiCarousel.propTypes = {
	children: PropTypes.oneOfType([ PropTypes.node, PropTypes.arrayOf(PropTypes.node) ]),
	responsive: PropTypes.shape({
		superLargeDesktop: PropTypes.shape({
			breakpoint: PropTypes.shape({
				max: PropTypes.number,
				min: PropTypes.number
			}),
			items: PropTypes.number
		}),
		desktop: PropTypes.shape({
			breakpoint: PropTypes.shape({
				max: PropTypes.number,
				min: PropTypes.number
			}),
			items: PropTypes.number
		}),
		tablet: PropTypes.shape({
			breakpoint: PropTypes.shape({
				max: PropTypes.number,
				min: PropTypes.number
			}),
			items: PropTypes.number
		}),
		mobile: PropTypes.shape({
			breakpoint: PropTypes.shape({
				max: PropTypes.number,
				min: PropTypes.number
			}),
			items: PropTypes.number
		})
	}),
	slidesToSlide: PropTypes.number,
	afterChange: PropTypes.func
};

export default MultiCarousel;
